import { Select, MenuItem } from "@material-ui/core";
import React, { useState, useEffect } from "react";
import { Button, Form } from "react-bootstrap";
import "./codeactmodal.css";
import codeActivationService from "../../../service/codeActivation/CodeActive";
import { AlertBs } from "../common";
import AlertMessage from "../common/AlertMessage";
const CodeActModal = ({ onClose, monthsList, setReload }) => {
  const CloseIcon = () => (
    <svg
      viewBox="0 0 24 24"
      width="20"
      height="20"
      stroke="gray"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
      borderRadius="100%"
    >
      <circle cx="12" cy="12" r="10" />
      <line x1="15" y1="9" x2="9" y2="15" />
      <line x1="9" y1="9" x2="15" y2="15" />
    </svg>
  );

  const [selectedMonths, setSelectedMonths] = useState([]);
  const [loading, setLoading] = useState(false);
  const handleModalContentClick = (e) => {
    // Prevent the click event from bubbling up to the wrapper div
    e.stopPropagation();
  };

  const handleMonthSelect = (event) => {
    const selectedOptions = Array.from(event.target.selectedOptions);

    const selectedMonths = selectedOptions.map((option) => option.value);
    setSelectedMonths(selectedMonths);
  };

  // const notifyDissmissed = () => {
  //   setnotify((prev) => ({
  //     ...prev,
  //     show: false,
  //   }));
  // };

  const [data, setdata] = useState({
    securityCode: "",
    accessCode: "",
    selectedMonth: monthsList[0].value,
  });

  console.log({ data });
  const [alert, setalert] = useState({
    show: false,
    varient: "",
    message: "",
  });
  const [notify, setnotify] = useState({
    show: false,
    message: "",
    type: "",
  });

  const notifyDissmissed = () => {
    setnotify((prev) => ({
      ...prev,
      show: false,
    }));
  };

  const changeHandler = (e) => {
    const { name, value } = e.target;
    setdata((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const submitHandler = () => {
    setLoading(true);
    const hasEmptyValues = Object.values(data).some((value) => value === "");
    if (hasEmptyValues) {
      setLoading(false);
      setnotify((prev) => ({
        ...prev,
        show: true,
        type: "danger",
        message: "Error: Please fill in all the fields.",
      }));
    } else {
      setLoading(true);
      const service = new codeActivationService();
      const formData = {
        access_code: data.accessCode,
        security_code: data.securityCode,
        selected_month: data.selectedMonth,
      };

      service.reOrderActivation(formData).then((response) => {
        if (response.status) {
          setLoading(false);
          setReload(true);
          setalert((prev) => ({
            ...prev,
            show: true,
            varient: "success",
            message: "Code Activation Successful",
          }));

          setdata((prevData) => ({
            ...prevData,
            securityCode: "",
            accessCode: "",
          }));
          // setnotify((prev) => ({
          //   ...prev,
          //   show: true,
          //   type: "success",
          // }));
        } else {
          setLoading(false);
          setalert((prev) => ({
            ...prev,
            show: true,
            varient: "danger",
            message: response.error.description,
          }));
        }
      });
    }
  };

  const closeAlert = () => {
    setalert((prev) => ({
      ...prev,
      show: false,
      varient: "",
      message: "",
    }));
  };

  const dissmissNotify = () => {
    setnotify((prev) => ({
      ...prev,
      show: false,
      message: "",
      type: "",
    }));
  };

  useEffect(() => {}, [data]);

  return (
    <div>
      <div className="modall-wrapper modal_latest" onClick={onClose}>
        <div className="modall">
          <button className="close-button" onClick={onClose}>
            <CloseIcon />
          </button>

          {/* <AlertMessage

          {/* <AlertMessage
             show={notify.show}
             message={notify.message}
             dismiss={dissmissNotify}
             type={notify.type}
            
            /> */}

          {/* <div style={{ width: "75%" }}>
            <AlertBs {...alert} close={closeAlert} />
          </div> */}

          <div style={{ width: "75%" }} onClick={handleModalContentClick}>
            <AlertBs {...alert} close={closeAlert} />
          </div>

          <div className="modall-content" onClick={handleModalContentClick}>
            <div className="bordergreen"></div>

            <div className="headlabel">Code Activation</div>
            <div className="modals">
              <div style={{ fontSize: "10px" }}>
                Please enter below details{" "}
              </div>
              <br />
              <Form.Group controlId="formCardNo">
                <Form.Group controlId="formPassword">
                  <Form.Label>Enter Activation Code</Form.Label>
                  <Form.Control
                    placeholder="Activation Code"
                    size="lg"
                    type="text"
                    name="accessCode"
                    onChange={changeHandler}
                    value={data.accessCode}
                  />
                </Form.Group>
                <Form.Label>Enter Security Code</Form.Label>
                <Form.Control
                  type="text"
                  size="lg"
                  // placeholder="xxxx-xxxx-xxxx-xxxx"
                  placeholder="security code"
                  name="securityCode"
                  onChange={changeHandler}
                  value={data.securityCode}
                />
              </Form.Group>
              <Form.Group controlId="formMonthSelect">
                <Form.Label>Month</Form.Label>
                <Select
                  className="select-boot"
                  placeholder="Select Month"
                  as="select"
                  name="selectedMonth"
                  onChange={changeHandler}
                  value={data.selectedMonth || ""}
                  defaultValue=""
                  displayEmpty
                  disabled
                >
                  <MenuItem value="" disabled style={{ cursor: "pointer" }}>
                    Select month
                  </MenuItem>
                  {monthsList.map((month) => (
                    <MenuItem
                      value={month.value}
                      key={month.value}
                      style={{ cursor: "pointer" }}
                      selected={data.selectedMonth === month.value}
                      disabled
                    >
                      {month.title}
                    </MenuItem>
                  ))}
                </Select>
              </Form.Group>
              <br />
              <Button
                style={{
                  fontSize: "10px",
                  borderRadius: "2px",
                  height: "28px",
                  width: "170px",
                }}
                variant="success"
                onClick={submitHandler}
                disabled={loading}
              >
                <strong>Process Activation</strong>
              </Button>
            </div>

            {/* )} */}
          </div>
        </div>
      </div>
      {notify.show && (
        <div onClick={handleModalContentClick}>
          <AlertMessage
            message={notify.message}
            dismiss={notifyDissmissed}
            type={notify.type}
            header={notify.header}
            show={notify.show}
          />
        </div>
      )}
    </div>
  );
};

export default CodeActModal;
